export default __webpack_public_path__ + "static/media/IconChevronDown.fb34bb26.svg";